/* 新規の豆定期便だけに、配送回数と請求周期を分けて表示する。 */
if (!customElements.get('beans-subscription-display')) {
  class BeansSubscriptionDisplay extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-page');
      if (!this.product || this.product.dataset.id !== '10673150689573') return;
      this.deliveries = new Map(
        Array.from(this.querySelectorAll('[data-subscription-variant]'), element => [
          element.dataset.subscriptionVariant,
          element.dataset.deliveries === '2' ? 2 : 1
        ])
      );
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateDisplay();
        });
      };
      this.product.addEventListener('change', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.product, {childList: true, subtree: true, characterData: true});
      this.updateDisplay();
    }

    disconnectedCallback() {
      this.product?.removeEventListener('change', this.schedule);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    updateDisplay() {
      this.product.querySelectorAll('.shopify_subscriptions_app_container[data-product-id="10673150689573"] section[data-variant-id]').forEach(section => {
        const deliveries = this.deliveries.get(section.dataset.variantId);
        if (!deliveries) return;
        const label = `月${deliveries}回お届け／毎月お支払い`;
        section.querySelectorAll('input[data-selling-plan-id="691393855781"]').forEach(input => {
          const title = input.closest('label')?.querySelector('.title_and_price_wrapper > span');
          if (title && title.textContent !== label) title.textContent = label;
          const accessibleLabel = input.dataset.variantPrice ? `${label}。商品価格 ${input.dataset.variantPrice}` : label;
          if (input.getAttribute('aria-label') !== accessibleLabel) input.setAttribute('aria-label', accessibleLabel);
        });
      });

      const variant = this.product.querySelector('form[action*="/cart/add"] input[name="id"]')?.value || this.dataset.variantId;
      const timing = this.deliveries.get(variant) === 2
        ? '※ お申し込み日を基準に月2回お届け。2回目は、毎月の基準日から約14日後が目安です。'
        : '※ お申し込み日を基準に、毎月1回お届けします。';
      const note = this.querySelector('[data-subscription-timing]');
      if (note && note.textContent !== timing) note.textContent = timing;
    }
  }
  customElements.define('beans-subscription-display', BeansSubscriptionDisplay);
}
